import type { AvailableShift, DraftSchedule } from '../types.js'

/**
 * Whether a draft found its month empty and the facility has since published shifts for it. The API says this
 * itself once it records the published shifts' fingerprint on a draft; until it is deployed everywhere, the app
 * reads it from the facility's open shifts so the worker is told to build again.
 */
export function draftBehindPublished(draft: DraftSchedule, published: readonly AvailableShift[] | null): boolean {
  return draft.flags.includes('nothing_published') && (published ?? []).some((shift) => shift.date.slice(0, 7) === draft.period)
}
